import { useFormContext, Controller } from "react-hook-form"
import Slider from "react-input-slider"

const MenuTitle = (title, type="") => {
  return (
    <div className={`filter_menu_title${type}`}>{title}</div>
  )
}

const MultiTypeBlock1 = ({contents}) => {
  const form = useFormContext()
  const displaySelects = (title, key, options) => {
    return (
      <>
        {title}
        <select {...form.register(key)} >
          {options.map((e) => {
            return <option value={e}>{e}</option>
          })}
        </select>
      </>
    )
  }
  const SearchPlayer = ({type}) => {
    const InputNameMap = {"Pitcher": 'Pitcher', "Batter": 'Batter', "Catcher": 'Catcher'}
    const ListNameMap = {Pitcher: 'PTList', Batter: 'BatSList'}
    return (
      <div className="filter_menu_col1">
        {type} <input type="text" {...form.register(InputNameMap[type])} />
        {type === 'Catcher'? []:
          <>
            <label className="col1"><input type="checkbox" value="R" name={type} {...form.register(ListNameMap[InputNameMap[type]])}/><span></span>R</label>
            <label className="col1"><input type="checkbox" value="L" name={type} {...form.register(ListNameMap[InputNameMap[type]])}/><span></span>L</label>
          </>
        }
      </div>
    )
  }
  return (
    <div className="filter_menu_block">
      <div className="filter_menu_col1">
        {displaySelects(contents[0].title, contents[0].key, contents[0].options)}
      </div>
      <SearchPlayer type="Pitcher" />
      <SearchPlayer type="Batter" />
      <SearchPlayer type="Catcher" />
      <div className="filter_menu_col1">
        {displaySelects(contents[1].title, contents[1].key, contents[1].options)}
      </div>
    </div>
  )
}

const displayCheckboxes = (col, key, form) => {
  return (
    <div className="filter_menu_col1">
      {col.boxes.map((e) => {
        return <label className={col.colClass}>{(e==="")? "" : (<input type="checkbox" value={e} name={key} {...form.register(key)}/>)}<span></span>{e}</label>
      })}
    </div>
  )
}

const CheckboxBlocks = ({content}) => {
  const form = useFormContext()
  return (
    <div className="filter_menu_block">
      {MenuTitle(content.title)}
      {content.cols.map((e) => (displayCheckboxes(e, content.key, form)))}
    </div>
  )
}

const displayCheckboxes2 = (col, title, field, onChange) => {
  return (
    <div className="filter_menu_col1">
      {col.boxes.map((e) => {
        return <label className={col.colClass}>{(e==="")? "" : (<input type="checkbox" value={e} name={title} onChange={onChange} checked={field.value && field.value.includes(e)} />)}<span></span>{e}</label>
      })}
    </div>
  )
}

const MultiCheckboxBlocks = ({content, rule}) => {
  const form = useFormContext()
  return (
    <div className="filter_menu_block">
      {MenuTitle(content.title)}
      <Controller control={form.control} name={content.key} defaultValue={[]}
        render={({ field }) => {
          const handleOnChange = (evt) => {
            const checked = evt.target.checked, val = evt.target.value
            if (checked) {
              if (rule[val] !== undefined) { //special option
                let tmpField = [...field.value]
                for (const v of rule[val]) {
                  if (!tmpField.includes(v)) tmpField.push(v)
                }
                tmpField.push(val)
                field.onChange(tmpField)
              } else {
                field.onChange([...field.value, val])
              }
            } else {
              if (rule[val] !== undefined) {
                let tmpField = [...field.value]
                tmpField = tmpField.filter((v)=>(!rule[val].includes(v) && v !== val))
                field.onChange(tmpField)
              } else {
                let tmpField = [...field.value], t = ""
                for (const k in rule) {
                  if (rule[k].includes(val)) t = k
                }
                tmpField = tmpField.filter((v)=>((v !== t && v !== val)))
                field.onChange(tmpField)
              }
            }
          }
          return (
            <>
              {content.cols.map((e) => (displayCheckboxes2(e, content.key, field, handleOnChange)))}
            </>
          )
        }}
      />
    </div>
  )
}

const MultiTypeBlock2 = () => {
  const form = useFormContext()
  const displayCheckbox = (list, name) => {
    return list.map((e) => {
      return <label className="col3"><input type="checkbox" value={e} name={name} {...form.register(name)} /><span></span>{e}</label>
    })
  }
  return (
    <div className="filter_menu_block">
      {MenuTitle("Outs & On-Base", 3)}
      <div className="filter_menu_col3">
        {displayCheckbox(["No Runner", "RISP"], "OBList")}
        {displayCheckbox(["0 out", "1 out", "2 outs"], "OList")}
      </div>
      <div className="filter_menu_basebag">
        <label className="filter_basebag_label"><input type="checkbox" value={1} name="壘上狀況" {...form.register("OBList")}/><div className="basebag1" /></label>
        <label className="filter_basebag_label"><input type="checkbox" value={2} name="壘上狀況" {...form.register("OBList")}/><div className="basebag2" /></label>
        <label className="filter_basebag_label"><input type="checkbox" value={3} name="壘上狀況" {...form.register("OBList")}/><div className="basebag3" /></label>
      </div>
    </div>
  )
}

const displaySlider = (title, key, form, defVal, max, min) => {
  const sliderStyle = {
    track: { backgroundColor: "#b3b3b3", width: "8vw", height: "3px" },
    active: { backgroundColor: "#4ca7e0" },
    thumb: { width: "0.93vw", height: "0.93vw", backgroundColor: "#4ca7e0" }
  }
  return (
    <div className="filter_menu_col2">
      <div className="filter_menu_title4">{title} {form.watch(key)}</div>
      <Controller control={form.control} name={key} defaultValue={defVal}
        render={({ field: { value, onChange } }) => (
          <Slider styles={sliderStyle} className="filter_slider" axis="x" xmax={max} xmin={min} xstep={1} x={value} onChange={({x}) => {onChange(x)}} />
        )}
      />
    </div>
  )
}

const MultiTypeBlock3 = ({content}) => {
  const form = useFormContext()
  return (
    <>
      <div className="filter_menu_block">
        {MenuTitle("Pitch Type", 3)}
        {content.map((e) => (displayCheckboxes({colClass:'col3', boxes:e}, "TagPList", form)))}
      </div>
      <div className="filter_menu_block">
        {displaySlider("Pitch Velo > =", "APP_VeloRel_Min", form, 80, 165, 80)}
        {displaySlider("Pitch Velo < =", "APP_VeloRel_Max", form, 80, 165, 80)}
        {displaySlider("Exit Velo > =", "ExitVelo_Min", form, 0, 200, 0)}
        {displaySlider("Exit Velo < =", "ExitVelo_Max", form, 0, 200, 0)}
        {displaySlider("Exit Angle > =", "ExitAngle_Min", form, -90, 90, -90)}
        {displaySlider("Exit Angle < =", "ExitAngle_Max", form, -90, 90, -90)}
      </div>
    </>
  )
}

const ZoneBlock = ({ form, value }) => {
  return (
    <label htmlFor={`zselect-${value}`}>
      <input type="checkbox" id={`zselect-${value}`} value={value} name='ZBList' {...form.register('ZBList')} />
      <span className="zb" />
    </label>
  );
};

const InnerZone = ({ form }) => {
  return (
    <div className="inner-zone">
      <div className="iz-col">
        <ZoneBlock value={1} form={form} />
        <ZoneBlock value={4} form={form} />
        <ZoneBlock value={7} form={form} />
      </div>
      <div className="iz-col">
        <ZoneBlock value={2} form={form} />
        <ZoneBlock value={5} form={form} />
        <ZoneBlock value={8} form={form} />
      </div>
      <div className="iz-col">
        <ZoneBlock value={3} form={form} />
        <ZoneBlock value={6} form={form} />
        <ZoneBlock value={9} form={form} />
      </div>
    </div>
  );
};

const OuterZone = ({ form }) => {
  return (
    <div className="outer-zone">
      <div className="oz-col">
        <ZoneBlock value={11} form={form} />
        <ZoneBlock value={13} form={form} />
      </div>
      <div className="oz-col">
        <ZoneBlock value={12} form={form} />
        <ZoneBlock value={14} form={form} />
      </div>
    </div>
  );
};

const ZoneCheckboxes = () => {
  const form = useFormContext()
  return (
    <div className="filter_menu_block">
      {MenuTitle("Zone")}
      <div className="zone">
        <InnerZone form={form} />
        <OuterZone form={form} />
      </div>
    </div>
  );
}

const SubmitAndClear = ({clearField}) => {
  const form = useFormContext()
  const handleReset = () => { form.reset(clearField) }
  return (
    <div className="filter_menu_bottom">
      <button className="btn_gray" type="button" onClick={handleReset} >Clear</button>
      <button className="btn_blue" type="submit" >Search</button>
    </div>
  )
}

export { MultiTypeBlock1, MultiTypeBlock2, MultiTypeBlock3, CheckboxBlocks, MultiCheckboxBlocks, ZoneCheckboxes, SubmitAndClear }